import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DivisionService } from 'src/app/services/division.service';
import { RegionService } from 'src/app/services/region.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';
import { ShowtreasuryremittedreportComponent } from '../showtreasuryremittedreport/showtreasuryremittedreport.component';

@Component({
  selector: 'app-beneficiaryreport',
  templateUrl: './beneficiaryreport.component.html',
  styleUrls: ['./beneficiaryreport.component.scss']
})
export class BeneficiaryreportComponent implements OnInit {
  regionList: any[];
  filterregionList: any[];
  divisionList: any[];
  filterdivisionList: any[];
  subdivisionList: any[];
  filterListsubdivisionList: any[];
  public RoleEnumType = RoleType;
  roleId: number;

  constructor(private formBuilder: FormBuilder,
    private regionService: RegionService,
    private divisionService: DivisionService,
    public tripDialog: MatDialog,
    private subdivisionService: SubDivisionService,
    private userSessionService: UserSessionService,) { 
      this.roleId = this.userSessionService.roleId();
    }
  form:FormGroup
  ngOnInit(): void {
    this.initializeValidators();
    this.getLookupRegion(true);
  }
  initializeValidators() {
    this.form = this.formBuilder.group({
      regionId: [null],
      divisionId: [null],
      subDivisionId: [null],
    });
  }
  getLookupRegion(refresh: boolean) {
    this.regionService.getLookUp(refresh).subscribe(result => {
      if (result) {
        this.regionList = [];
        this.filterregionList = [];
        this.regionList = result;
        this.filterregionList = this.regionList.slice();
        const regionLength = this.regionList.length;
        if (regionLength === 1) {
          this.form.controls['regionId'].setValue(this.regionList[0].key);
          this.getLookupDivision(this.form.value.regionId);
        }
      }
    })
  }
  regionChange() {
    this.getLookupDivision(this.form.value.regionId);
    this.form.controls['divisionId'].setValue(0);
    this.form.controls['subDivisionId'].setValue(0);
  }





 getLookupDivision(id) {
    this.divisionService.getLookUpbyId(true, id).subscribe(result => {
      if (result) {
        this.divisionList = [];
        this.filterdivisionList = [];
        this.divisionList = result;
        this.filterdivisionList = this.divisionList.slice();
        const divisionLength = this.divisionList.length;
        if (divisionLength === 1) {
          this.form.controls['divisionId'].setValue(this.divisionList[0].key);
          this.getLookupSubDivision(this.form.value.divisionId);
        }
      }
    })
  }
  divisionChange() {
    this.getLookupSubDivision(this.form.value.divisionId);
    this.form.controls['subDivisionId'].setValue(0);
  }
  getLookupSubDivision(id) {
    this.subdivisionService.getLookUpbyId(true, id).subscribe(result => {
      if (result) {
        this.subdivisionList = [];
        this.filterListsubdivisionList = [];
        this.subdivisionList = result;
        this.filterListsubdivisionList = this.subdivisionList.slice();
        const subdivisionLength = this.subdivisionList?.length;
        if (subdivisionLength === 1) {
          this.form.controls['subDivisionId'].setValue(this.subdivisionList[0].key);
        }
      }
    })
  }
  clear() {
 
    if(this.roleId === this.RoleEnumType.ExecutiveEngineer){
      this.form.controls['ScheduledStart'].setValue(null);
      this.form.controls['ScheduledEnd'].setValue(null);
      this.form.controls['subDivisionId'].setValue(null);
    }
    if(this.roleId === this.RoleEnumType.SuperintendEngineer){
      this.form.controls['divisionId'].setValue(null);
      this.form.controls['subDivisionId'].setValue(null);
    }
    if(this.roleId === this.RoleEnumType.SuperAdmin ||
      this.roleId === this.RoleEnumType.ChiefEngineer ||
      this.roleId === this.RoleEnumType.SeniorEngineer ||
      this.roleId === this.RoleEnumType.Root  ){
      this.initializeValidators();
    }
  }
  showReport() {
    if (this.form.valid) {
     
      if (this.form.value.regionId == null) {
        this.form.controls['regionId'].setValue(0);
      }
      if (this.form.value.divisionId == null) {
        this.form.controls['divisionId'].setValue(0);
      }
      if (this.form.value.subDivisionId == null) {
        this.form.controls['subDivisionId'].setValue(0);
      }
      const data = {
        divisionId: this.form.value.divisionId,
        regionId: this.form.value.regionId,
        subDivisionId: this.form.value.subDivisionId,
        ReportType: 16,
      }
      const dialogRef = this.tripDialog.open(ShowtreasuryremittedreportComponent, {
        autoFocus: false,
        disableClose: true,
        width: '100%',
        height: '90%',
        panelClass: 'mat-dialog-report',
        data
      })
      dialogRef.afterClosed().subscribe(() => {
      });
    } else {
      this.validateFormControl();
    }
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

}
